<!--
 * @Descripttion: 修改了一些内容
 * @version: v1.0
 * @Author: htt
 * @Date: 2021-09-24 11:21:55
 * @LastEditors: htt
 * @LastEditTime: 2021-12-02 09:32:13
-->
<template>
  <div>
    <!-- <template v-if="!isAdmin"> -->
    <div v-loading="loading" class="info main_center">
      <div>
        <step
          ref="step"
          :flag="flag"
          :steps="steps"
          :step-list.sync="stepList"
          :rule-form="ruleForm"
          :bid-data="bidData"
          :bid-total="bidTotal"
          :bid-query="bidQuery"
          :floor-data="floorData"
          :floor-total="floorTotal"
          :floor-query="floorQuery"
          :seat-data="seatData"
          :seat-total="seatTotal"
          :seat-query="seatQuery"
          :monitor-data="monitorData"
          :monitor-total="monitorTotal"
          :monitor-query="monitorQuery"
          @getBidData="getBidData"
          @openUpdate="openUpdate"
          @handleDelete="handleDelete"
          @getFloorData="getFloorData"
          @openUpdatefloor="openUpdatefloor"
          @handleFloorDelete="handleFloorDelete"
          @getSeatData="getSeatData"
          @openSeatUpdate="openSeatUpdate"
          @handleSeatDelete="handleSeatDelete"
          @handleSeatClose="handleSeatClose"
          @getMonitorData="getMonitorData"
          @openMonitorUpdate="openMonitorUpdate"
          @handleMonitorDelete="handleMonitorDelete"
        />
      </div>
    </div>
    <info-detail
      v-if="infoVisible"
      ref="detailInfo"
      @refreshDataList="getBidData"
    />
    <floor-detail
      v-if="infoVisible"
      ref="floorInfo"
      @refreshDataList="getFloorData"
    />
    <seat-detail
      v-if="seatVisible"
      ref="detailSeat"
      @refreshDataList="getSeatData"
    />
    <monitor-detail
      v-if="monitorVisible"
      ref="detailMonitor"
      @refreshDataList="getMonitorData"
    />
  </div>
</template>
<script>
import Step from '@/components/Step'
import floorDetail from './compontents/floorDetail.vue'
import InfoDetail from './compontents/infoDetail.vue'
import SeatDetail from './compontents/seatDetail.vue'
import MonitorDetail from './compontents/monitorDetail.vue'
import {
  stepsFinished,
  infoMaintainList,
  infoMaintainDelete,
  infoSeatList,
  infoSeatDelete,
  infoSeatSave,
  infoMonitorList,
  infoMonitorDelete,
  infoFloorList,
  infoFloorDelete
} from '@/server/field'
export default {
  components: {
    Step,
    floorDetail,
    InfoDetail,
    SeatDetail,
    MonitorDetail
  },
  props: {
    currentVal: {
      type: Number,
      default: 1
    },
    errorStep: {
      type: Number,
      default: 0
    },
    stepArray: {
      type: Array,
      default: function() {
        return ['步骤1', '步骤2', '步骤3', '步骤4', '步骤5']
      }
    }
  },
  data() {
    return {
      steps: [
        {
          title: '基本信息维护'
        },
        {
          title: '场地楼层维护'
        },
        {
          title: '场地信息维护'
        },
        {
          title: '机位信息维护'
        },
        {
          title: '监控信息维护'
        }
      ],
      loading: false,
      flag: true,
      stepList: [],
      active: 0,
      ruleForm: {
        tradeOrgId: '',
        tradeOrgName: '',
        regionCode: '',
        linkMan: '',
        linkPhone: '',
        remark: ''
      },
      bidData: [],
      bidTotal: 0,
      bidQuery: {
        page: 1,
        limit: 7
      },
      floorData: [],
      floorTotal: 0,
      floorQuery: {
        page: 1,
        limit: 7
      },
      infoVisible: false,
      seatData: [],
      seatTotal: 0,
      seatQuery: {
        page: 1,
        limit: 7
      },
      seatVisible: false,
      monitorData: [],
      monitorTotal: 0,
      monitorQuery: {
        page: 1,
        limit: 7
      },
      monitorVisible: false
    }
  },
  computed: {
    orgId: {
      get() { return this.$store.state.user.userinfo.orgInfo.orgId }
    }
  },
  activated() {
    this.floorQuery = this.$options.data.call(this).floorQuery
    this.bidQuery = this.$options.data.call(this).bidQuery
    this.seatQuery = this.$options.data.call(this).seatQuery
    this.monitorQuery = this.$options.data.call(this).monitorQuery
    // this.getData()
    this.init()
    this.getFloorData()
    this.getBidData()
    this.getSeatData()
    this.getMonitorData()
  },
  methods: {
    init() {
      this.loading = true
      const row = JSON.parse(sessionStorage.getItem('row'))
      if(row && row.tradeOrgId){
        this.$nextTick(() => {
          this.getSteps(row.tradeOrgId)
        })
      }
      if (row && row.tradeOrgId) {
        this.ruleForm={...row}
      } else {
        this.ruleForm={};
        this.ruleForm={
          tradeOrgId: '',
          linkMan: '',
          linkPhone: ''
        };
        this.$refs.step.$refs.ruleFormref.resetFields();
        // getEvalRoomInfo(this.ruleForm.tradeOrgId).then(res => {
        //   this.loading = false
        //   if (res.data.code === '1') {
        //     const { data } = res.data
        //     // this.ruleForm.tradeOrgId = data.tradeOrgId
        //     this.ruleForm.linkMan = data.linkMan
        //     this.ruleForm.linkPhone = data.linkPhone
        //     if (data && data.linkMan) {
        //       this.flag = true
        //     } else {
        //       this.flag = false
        //     }
        //   }
        // })
      }

      this.loading = false
    },
    // 获取节点
    getSteps(orgId) {
      let that=this;
      that.stepList = []
      stepsFinished(orgId).then(res => {
        if (res.data.code === '1') {
          const { data } = res.data
          for (var key in data) {
            let cnt=data[key];
            if (cnt>0){
              continue
            }
            const test = key.split('')
            that.stepList.push(Number(test[test.length - 1])-1)
            that.stepList.sort()
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 获取场地楼层数据
    getFloorData() {
      infoFloorList({
        page: this.floorQuery.page,
        rows: this.floorQuery.limit,
        filter: {
          tradeOrgId: this.ruleForm.tradeOrgId
        }
      }).then(res => {
        if (res.data.code) {
          this.$message.error(res.data.msg)
          return
        }
        const { data } = res
        this.floorData = data.rows || []
        this.floorTotal = data.total || 0
      })
    },
    // 场地编辑
    openUpdatefloor(id) {
      this.infoVisible = true
      this.$nextTick(() => {
        this.$refs.floorInfo.init(id, this.ruleForm.tradeOrgId)
      })
    },
    // 场地删除
    handleFloorDelete(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          infoFloorDelete({ id })
            .then((res) => {
              if (res.data.code === '1') {
                this.getFloorData()
                this.$message.success(res.data.msg)
              } else {
                this.$message.error(res.data.msg)
              }
            })
        })
    },
    // 获取场地数据
    getBidData() {
      infoMaintainList({
        page: this.bidQuery.page,
        rows: this.bidQuery.limit,
        filter: {
          tradeOrgId: this.ruleForm.tradeOrgId
        }
      }).then(res => {
        if (res.data.code) {
          this.$message.error(res.data.msg)
          return
        }
        const { data } = res
        this.bidData = data.rows || []
        this.bidTotal = data.total || 0
      })
    },
    // 场地编辑
    openUpdate(id) {
      this.infoVisible = true
      this.$nextTick(() => {
        this.$refs.detailInfo.init(id, this.ruleForm.tradeOrgId,this.ruleForm.regionCode)
      })
    },
    // 场地删除
    handleDelete(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          infoMaintainDelete({ id })
            .then((res) => {
              if (res.data.code === '1') {
                this.getBidData()
                this.$message.success(res.data.msg)
              } else {
                this.$message.error(res.data.msg)
              }
            })
        })
    },
    // 获取机位数据
    getSeatData() {
      infoSeatList({
        page: this.seatQuery.page,
        rows: this.seatQuery.limit,
        filter: {
          tradeOrgId: this.ruleForm.tradeOrgId
        }
      }).then(res => {
        if (res.data.code) {
          this.$message.error(res.data.msg)
          return
        }
        const { data } = res
        this.seatData = data.rows || []
        this.seatTotal = data.total || 0
      })
    },
    // 机位编辑
    openSeatUpdate(id) {
      this.seatVisible = true
      this.$nextTick(() => {
        this.$refs.detailSeat.init(id, this.ruleForm.tradeOrgId)
      })
    },
    // 机位删除
    handleSeatDelete(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          infoSeatDelete({ id })
            .then((res) => {
              if (res.data.code === '1') {
                this.getSeatData()
                this.$message.success(res.data.msg)
              } else {
                this.$message.error(res.data.msg)
              }
            })
        })
    },
    // 机位状态
    handleSeatClose(row) {
      const param = { seatStatus: row.seatStatus === 0 ? 1 : 0 }
      const params = Object.assign(row, param)
      infoSeatSave(params).then(res => {
        if (res.data.code === '1') {
          this.$message.success(res.data.msg)
          this.getSeatData()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 获取监控数据
    getMonitorData() {
      infoMonitorList({
        page: this.monitorQuery.page,
        rows: this.monitorQuery.limit,
        filter: {
          tradeOrgId: this.ruleForm.tradeOrgId
        }
      }).then(res => {
        if (res.data.code) {
          this.$message.error(res.data.msg)
          return
        }
        const { data } = res
        this.monitorData = data.rows || []
        this.monitorTotal = data.total || 0
      })
    },
    // 监控编辑
    openMonitorUpdate(id) {
      this.monitorVisible = true
      this.$nextTick(() => {
        this.$refs.detailMonitor.init(id, this.ruleForm.tradeOrgId)
      })
    },
    // 监控删除
    handleMonitorDelete(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          infoMonitorDelete({ id })
            .then((res) => {
              if (res.data.code === '1') {
                this.getMonitorData()
                this.$message.success(res.data.msg)
              } else {
                this.$message.error(res.data.msg)
              }
            })
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.info{
  //margin-top:20px!important;
  // padding:42px 32px
}
</style>
